import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { SwiperOptions } from 'swiper';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { LoaderOverlayService } from 'src/app/core/services/loader-overlay.service';
import { NavigationExtras, Router } from '@angular/router';
import { ViewCartService } from 'src/app/shared/services/view-cart.service';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PaymentGatewayService } from 'src/app/shared/services/payment-gateway.service';
import { RemoveItemWarningComponent } from 'src/app/shared/components/remove-item-warning/remove-item-warning.component';
import { delay, retryWhen, take } from 'rxjs/operators';
import { LoginDialogComponent } from 'src/app/shared/components/login-dialog/login-dialog.component';
import { environment } from 'src/environments/environment';
import { CouponsService } from 'src/app/shared/services/coupons.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StarryTipComponent } from 'src/app/shared/components/starry-tip/starry-tip.component';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ChooseAgainDialogComponent } from '../choose-again-dialog/choose-again-dialog.component';
import { RewardsAndOffersDialogComponent } from '../rewards-and-offers-dialog/rewards-and-offers-dialog.component';
import { Meta, Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { StoreService } from 'src/app/shared/services/store.service';
import { MenuService } from 'src/app/shared/services/menu.service';
import * as LZString from 'lz-string';
import { LoadMSRBalanceSheetComponent } from 'src/app/ordering/load-msrbalance-sheet/load-msrbalance-sheet.component';
import { MsrCardService } from 'src/app/shared/services/msr-card.service';
declare var dataLayer;
import { CmsService } from 'src/app/shared/services/cms.service';
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CartComponent implements OnInit, OnDestroy {
  public isPhone: boolean;
  public questionText;
  public viewCartFormGroup: FormGroup;
  public isLoggedIn: boolean = true;
  public isCustomised: boolean = true;
  public breadCrumbData: Array<Object> = [
    { title: 'Order', path: 'ordering' },
    { title: 'Your Cart', path: 'cart' },
  ];
  public selectedStatus: number;
  public toggleForm: boolean;
  public ripColor: any = '#00814d38';
  public loader: boolean = false;
  public basketData: any = [];
  public cartData: any;
  public cartItemQuantity;
  public orderId: any = '';
  public paymentDetails: any = [];
  public userProfileInfo = JSON.parse(localStorage.getItem('user_profile'));
  public tempCatId: any = '';
  public tempProductImg: any = '';
  public disablePayBtn: boolean = false;
  public verifyLoggedInUser: boolean;
  public server = environment.APIEndpoint;
  public title = 'Cart | Tata Starbucks';
  public cohortData = JSON.parse(localStorage.getItem('cohortData'));
  public allOffers: any;
  public applicableOffersArray: any;
  public nonApplicableOffersArray: any;
  public isMobile: boolean;
  public viewMore: boolean = false;
  public isContentToggled = [];
  public nonEditedContent = [];
  public editedContent = [];
  public content = [];
  public showDiscountBar: boolean = false;
  public showOfferShimmer: boolean;
  public applicableOffersArrayNew: any = [];
  public showCartShimmer: boolean;
  public storeDetail: any;
  public appliedCpnArray: any[];
  public msrCardsData: any = [];
  public cardReloadedBalance: any;
  public pickupDetails;
  public request;
  public userType: string;
  public userId: any;
  public tierType: any;
  public applyProductId = [];
  public invoiceLevelCoupon = [];
  public itemLevelCoupon = [];
  public couponcodes = [];
  public appliedCouponData;
  public itemCustomizationArr = [];
  public inStockAllProduct: boolean;
  public inStockAllModifier: boolean;
  public defaultChecked: boolean = true;
  public showDecrementShimmer: boolean = false;
  public removedItemIndex: any;
  public storeAwayFrom: any;
  public noItem: boolean;
  public noTrack:boolean=true;
  fname: any;
  mobileNumber: any;
  emailId: any;
  constructor(
    private _bottomSheet: MatBottomSheet,
    private fb: FormBuilder,
    private loaderOverlayService: LoaderOverlayService,
    public router: Router,
    private msrCardService: MsrCardService,
    private couponService: CouponsService,
    private titleService: Title,
    private metaService: Meta,
    private menuService: MenuService,
    private cmsService: CmsService,
    private encryptDecryptService: EncryptDecryptService,
    private _snackBar: MatSnackBar,
    private storeService: StoreService,
    private storageService: StorageService,
    private viewCart: ViewCartService,
    private commonFunction: CommonFunctions,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private paymentGatewayService: PaymentGatewayService,
    private _location: Location,
  ) {
    this.verifyLoggedInUser = this.commonFunction.verifyLoggedInUser();
    this.isMobile = this.commonFunction.identifyDeviceType();
    this.getNavData();
    this.getPayData();
    if (sessionStorage.getItem('updateCart') == null) {
      this.getBasket();
      this.createForm();
    } else if (sessionStorage.getItem('updateCart') == 'true') {
      this.updateCart();
    }
    this.paymentDetails =
      JSON.parse(localStorage.getItem('paymentModeDetails')) === null
        ? []
        : JSON.parse(localStorage.getItem('paymentModeDetails'));
    this.disablePayBtn = this.paymentDetails.length == 0 ? true : false;
    if (!this.verifyLoggedInUser) {
      this.paymentDetails = [
        {
          paymentMode: 'ONLINE',
          data: 'ONLINE',
        },
      ];
      localStorage.setItem(
        'paymentModeDetails',
        JSON.stringify(this.paymentDetails)
      );
    }
  }
  ngOnInit(): void {
    this.isPhone = JSON.parse(sessionStorage.getItem('isPhone'));
    this.refreshMenu();
this.createForm();
    this.selectedStatus = 2;
    this.baristaMessage();
    this.setSeoData();
    sessionStorage.removeItem('browserBack');
    sessionStorage.removeItem('subMenuIx');
    sessionStorage.removeItem('selectedTagList');
    sessionStorage.removeItem('productForCustomisation');
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
    this.cartPageGA();
    sessionStorage.removeItem('orderFrom');
  }
  ngOnDestroy(): void {
    sessionStorage.setItem(
      'pickUpValue',
      this.viewCartFormGroup.get('pickuptypes').value
    );
  }
  createForm() {
    this.viewCartFormGroup = this.fb.group({
      textmssg: [''],
      pickuptypes: ['takeaway'],
      fname: [ '', Validators.compose([Validators.required, Validators.minLength(1), Validators.pattern('[a-zA-Z ][a-zA-Z ]+[a-zA-Z ]$')])],
      mobileNumber: ['', Validators.compose([Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(10)])],
      emailId: ['',Validators.compose([Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$')])],
    });
    this.setForm();
  }
  config: SwiperOptions = { 
    pagination: { el: '.swiper-pagination', clickable: true },
    autoHeight: true,
    allowTouchMove: true,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      480: {
        spaceBetween: 20,
        slidesPerView: 1.2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: false,
  };
  onSwiper([swiper]) { }
  setControlledSwiper(event) { }
  applyReward(): void {
    let data = {
      couponsArray: this.appliedCpnArray,
      applicableOffersArrayNew: this.applicableOffersArrayNew,
      nonApplicableOffersArray: this.nonApplicableOffersArray,
    };
    const bottomSheetRef = this._bottomSheet.open(
      RewardsAndOffersDialogComponent,
      {
        backdropClass: 'light-backdrop',
        panelClass: ['full_width_panel', 'rewards-bottom-sheet'],
        data,
      }
    );
    bottomSheetRef.afterDismissed().subscribe((res) => {
      this.getBasket();
    });
  }
  public removeCoupon(index, item) {
    item.couponcode = '';
    item.price = item.baseprice;
  }
  public decrement(item, i) {
    this.removedItemIndex = i;
    this.showDecrementShimmer = true;
    let ReqBodyArray = JSON.parse(sessionStorage.getItem('finalReqBodyArray'));
    let updatedReqBodyArray =
      ReqBodyArray && ReqBodyArray.filter((item) => +item.id !== +item.id);
    sessionStorage.setItem(
      'finalReqBodyArray',
      JSON.stringify(updatedReqBodyArray)
    );
    if (item.quantity > 1) {
      item.quantity -= 1;
      this.updateLineItem(item);
      this.removeFromlocal(item);
      this.removeFromCartGA(item, i);
    } else if (item.quantity == 1) {
      const dialogRef = this.dialog.open(RemoveItemWarningComponent, {
        panelClass: 'expand-image-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'no') {
          item.quantity = 1;
          this.showDecrementShimmer = false;
        } else if (result === 'yes') {
          item.quantity = 0;
          this.cartItemQuantity = 0;
          localStorage.removeItem('manualCouponCode');
          this.deleteLineItem(item);
          this.removeFromlocal(item);
          this.removeFromCartGA(item, i);
        }
      });
    } else if ((item.quantity = 1 && this.cartData['items'].length != 1)) {
      item.quantity = 0;
      this.deleteLineItem(item);
      this.removeFromCartGA(item, i);
      sessionStorage.removeItem('localcartItem');
    }
  }
  /**
   * Method to remove item from local cart
   */
  public removeFromlocal(item) {
    let localcartItem = JSON.parse(sessionStorage.getItem('localcartItem'));
    if (localcartItem) {
      let cartItem = localcartItem.filter(
        (data) => (+data.myprice !== +item.price) && (data.id === item.id)
      );
      sessionStorage.setItem('localcartItem', JSON.stringify(cartItem));
    }
  }
  public increment(item) {
    item.quantity += 1;
    this.updateLineItem(item);
  }
  public incrementItem;
  public increment1(item) {
    if (!item.inStock || item.modifter === false) {
      return;
    }
    sessionStorage.setItem('previosPage', 'CartPDP');
    let menuListItem = JSON.parse(
      LZString.decompress(localStorage.getItem('menuListItem'))
    );
    if (menuListItem) {
      menuListItem.forEach((res) => {
        res['subCategories'].forEach((ress) => {
          ress['items'].forEach((itm) => {
            if (itm['id'] === item['id']) {
              this.incrementItem = itm;
              localStorage.setItem('selectedItem', JSON.stringify(itm));
              itm['options'] != null
                ? this.defaultCustomized(itm['options']['customization'])
                : '';
            }
          });
        });
      });
      this.incrementItem['lineID'] = item.lineItemId;
      this.repeatItem(this.incrementItem);
    }
  }
  repeatItem(data: any) {
    const dialogRef = this.dialog.open(ChooseAgainDialogComponent, {
      width: '600px',
      panelClass: 'dialog-no-padding',
      data: { 'data': data, 'isCart': true }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == undefined && this.router.url == '/cart') {
        this.orderCancelGA();
      }
      if (result && result['status'] === 200) {
        this.getBasket();
      }
    });
  }
  public patchForm(cartData){
    this.viewCartFormGroup.get('fname').patchValue(cartData.customerName);
    this.viewCartFormGroup.get('mobileNumber').patchValue(cartData.customerMobileNumber);
    this.viewCartFormGroup.get('emailId').patchValue(cartData.customerEmailId);
  }
  public getBasket(): void {
    this.loader = true;
    this.showCartShimmer = true;
    let basketId = this.storageService.getBasketId();
    let data = {
      basketId: basketId,
    };
    if (basketId == null || !basketId) {
      this.router.navigate(['/ordering']);
      return;
    } else {
      this.viewCart.getbasketItem(data).subscribe((res) => {
        this.cartData = res['response'];
        if(this.cartData['customerName']  !== '' || this.cartData['customerMobileNumber'] !== '' || this.cartData['customerEmailId'] !== ''){
         this.patchForm(this.cartData)
        }
        if (res['response'] && res['response']['items'].length === 0) {
          this.noItem = true;
        } else {
          this.inStockAllProduct = res['response']['items'].every(
            (data) => data.inStock
          );
          this.checkInStockModifier(res['response']);
          this.getChorotItem();
          this.filterCoupon(this.cartData);
          let cardDataItemList = this.cartData['items'];
          let str;
          for (let item of cardDataItemList) {
            str = '';
            if (item.options != null) {
              for (let option of item.options) {
                for (let selection of option.selections) {
                  str = str + selection.name + ',';
                }
              }
            } else {
              str = 'a';
            }
            str = str.slice(0, -1);
            this.itemCustomizationArr.push(str);
          }
          this.appliedCouponData = this.cartData['coupons'];
          this.applyCoupons(this.appliedCouponData);
          this.productInCart(this.cartData);
          localStorage.setItem('snackbarData', JSON.stringify(res));
          for (let i = 0; i < this.itemCustomizationArr.length; i++) {
            this.nonEditedContent.push(this.itemCustomizationArr[i]);
            this.editedContent.push(this.itemCustomizationArr[i].slice(0, 60));
            this.content.push(this.itemCustomizationArr[i].slice(0, 60));
            this.isContentToggled.push(false);
          }
          this.setCartItems();
          this.loader = false;
          this.showCartShimmer = false;
        }
      }, (error: any) => {
        this.router.navigate(['/ordering']);
      })
    }
  }
  public checkOOS(): void {
    let basketId = this.storageService.getBasketId();
    let data = {
      basketId: basketId,
    };
    if (basketId === null) {
      this.router.navigate(['/ordering']);
      return;
    }
    this.loaderOverlayService.showLoader();
    this.viewCart.getbasketItem(data).subscribe(
      (res) => {
        this.loaderOverlayService.hideLoader();
        this.cartData = res['response'];
        if (res['response'] && res['response']['items'].length === 0) {
          this.router.navigate(['/ordering']);
        } else {
          this.inStockAllProduct = res['response']['items'].every(
            (data) => data.inStock
          );
          this.checkInStockModifier(res['response']);
          this.placeFinalOrder();
        }
      }, (error: any) => {
        this.router.navigate(['/ordering']);
      }
    );
  }
  /**
* Method to validate inStock at modifier level
@param data conatins added item in cart
*/
  checkInStockModifier(data) {
    data['items'].forEach((itm) => {
      let modifierArry = [];
      if (itm.options) {
        itm.options.forEach((opt) => {
          if (opt.selections) {
            opt.selections.forEach((sel) => {
              if (!sel.inStock) {
                itm['modifter'] = false;
                modifierArry.push(sel['name']);
                itm['modifterName'] = modifierArry;
              }
            });
          }
        });
      }
    });
    this.inStockAllModifier = data['items'].some(
      (data) => data.modifter === false
    );
    data['items'].forEach((itm) => {
      if (!itm.hasOwnProperty('modifter')) {
        itm['modifter'] = true;
      }
    });
  }
  /**
   * Method to load latest menu by storeId
   */
  public refreshMenu() {
    let shopId = sessionStorage.getItem('storeId');
    if (shopId) {
      let requestPayload = {
        storeId: shopId,
        'channel':'&channel=mop-pickup'
      };
      this.menuService
        .getMenuList(requestPayload)
        .pipe(
          retryWhen((err) => {
            return err.pipe(delay(1000), take(3));
          })
        )
        .subscribe(
          (res) => {
            if (res['response'] && res['response'].length !== 0) {
              res['response'].sort(
                (a, b) =>
                  parseFloat(a.displayOrder) - parseFloat(b.displayOrder)
              );
              res['response'].forEach((sub) => {
                sub['subCategories'].sort(
                  (a, b) =>
                    parseFloat(a.displayOrder) - parseFloat(b.displayOrder)
                );
              });
              res['response'] = res['response'].filter(
                (itemss) => !itemss.hideForCustomer
              );
              res['response'].forEach((sub) => {
                sub['subCategories'] = sub['subCategories'].filter(
                  (itemss) => !itemss.hideForCustomer
                );
                sub['subCategories'].forEach((itm) => {
                  itm['items'] = itm['items'].filter(
                    (itemss) => !itemss.hideForCustomer
                  );
                });
              });
              localStorage.setItem(
                'menuListItem',
                LZString.compress(JSON.stringify(res['response']))
              );
            }
          },
          (error) => { }
        );
    }
  }
  applyCoupons(appliedCouponData) {
    this.invoiceLevelCoupon = [];
    this.itemLevelCoupon = [];
    if (appliedCouponData.length != 0) {
      for (let i = 0; i < appliedCouponData.length; i++) {
        if (appliedCouponData[i]['conditionLevel'] === 'invoice') {
          this.invoiceLevelCoupon.push(appliedCouponData[i]);
        }
      }
    }
  }
  offersShow(applyProductId) {
    for (let i = 0; i < this.cartData['items'].length; i++) {
      if (applyProductId.includes(this.cartData['items'][i]['id'])) {
        this.appliedCouponData.map((res) => {
          if (this.cartData['items'][i]['id'] === res['itemsIds'][0]) {
            this.cartData['items'][i]['cname'] = res['promotionName'];
            this.cartData['items'][i]['conditionLevel'] = res['conditionLevel'];
          }
        });
      }
    }
  }
  filterCoupon(cartData) {
    let x;
    let z = [];
    for (let i = 0; i < cartData['items'].length; i++) {
      z = [];
      if (cartData['items'][i]['coupon'].length != 0) {
        for (let j = 0; j < cartData['items'][i]['coupon'].length; j++) {
          x = cartData['coupons'].find((y) => {
            if (y.promoCategory === 'bxgy') {
              return y.couponCode == cartData['items'][i]['coupon'][j];
            } else {
              let data =
                y.couponCode == cartData['items'][i]['coupon'][j] &&
                +y.itemsIds[0] === +cartData['items'][i]['id'];
              return data;
            }
          });
          z.push(x);
        }
        z = z.reduce((acc, val) => acc.concat(val), []);
        cartData['items'][i]['couponNew'] = z;
      }
    }
  }
  itemIdOfCart = [];
  public productInCart(cartData) {
    this.itemIdOfCart = [];
    for (let i = 0; i < cartData['items'].length; i++) {
      this.itemIdOfCart.push(this.cartData['items'][i]['id']);
    }
    this.crossAndUpSell(this.itemIdOfCart);
  }
  public setCartItems() {
    let order = this.storageService.getOrderType();
    if (order === 'reorder') {
      this.reorderStore();
      let menuListItem = JSON.parse(
        LZString.decompress(localStorage.getItem('menuListItem'))
      );
      menuListItem.forEach((menu) => {
        menu['subCategories'].forEach((subCat) => {
          subCat['items'].forEach((itmss) => {
            this.cartData['items'].forEach((data, index) => {
              if (+data.id === +itmss['id']) {
                this.cartData['items'][index]['image'] =
                  itmss['images']['small'][0]['url'];
                this.cartData['items'][index]['parameters'] =
                  itmss['parameters'];
              }
            });
          });
        });
      });
    } else {
      let menuListItem = JSON.parse(
        LZString.decompress(localStorage.getItem('menuListItem'))
      );
      if (menuListItem) {
        let menuListItem = JSON.parse(
          LZString.decompress(localStorage.getItem('menuListItem'))
        );
        menuListItem.forEach((menu) => {
          menu['subCategories'].forEach((subCat) => {
            subCat['items'].forEach((itmss) => {
              this.cartData['items'].forEach((data, index) => {
                if (+data.id === +itmss['id']) {
                  this.cartData['items'][index]['image'] =
                    itmss['images']['small'][0]['url'];
                  this.cartData['items'][index]['parameters'] =
                    itmss['parameters'];
                }
              });
            });
          });
        });
      }
    }
  }
  public reorderStore() {
    let state = this.storageService.getState();
    if (!state) {
      this.storeService.clearStoreList();
      let obj = {
        lat: this.cartData['store']['lattitude'],
        lng: this.cartData['store']['longitude'],
      };
      this.storeService.getStoresCache(obj).subscribe(
        (response) => {
          let store = response['response'];
          if (store) {
            this.storeDetail = store.find(
              (data) => +data.shopId === +this.cartData['store']['storeId']
            );
            this.getMenus(this.storeDetail['shopId']);
          }
        },
        (error) => { }
      );
    }
  }
  getMenus(shopId) {
    sessionStorage.setItem('storeId', shopId);
    let requestPayload = {
      storeId: shopId,
      'channel':'&channel=mop-pickup'
    };
    this.menuService
      .getMenuList(requestPayload)
      .pipe(
        retryWhen((err) => {
          return err.pipe(delay(1000), take(3));
        })
      )
      .subscribe(
        (res) => {
          if (res['response'] && res['response'].length !== 0) {
            res['response'].sort(
              (a, b) => parseFloat(a.displayOrder) - parseFloat(b.displayOrder)
            );
            res['response'].forEach((sub) => {
              sub['subCategories'].sort(
                (a, b) =>
                  parseFloat(a.displayOrder) - parseFloat(b.displayOrder)
              );
            });
            res['response'] = res['response'].filter(
              (itemss) => !itemss.hideForCustomer
            );
            res['response'].forEach((sub) => {
              sub['subCategories'] = sub['subCategories'].filter(
                (itemss) => !itemss.hideForCustomer
              );
              sub['subCategories'].forEach((itm) => {
                itm['items'] = itm['items'].filter(
                  (itemss) => !itemss.hideForCustomer
                );
              });
            });
            localStorage.setItem(
              'menuListItem',
              LZString.compress(JSON.stringify(res['response']))
            );
            this.setState();
          } else {
          }
        },
        (error) => { }
      );
  }
  setState() {
    let allMenu = JSON.parse(
      LZString.decompress(localStorage.getItem('menuListItem'))
    );
    let store = 'noStore';
    let state = {
      data: allMenu ? allMenu : [],
      storeDetails: this.storeDetail ? this.storeDetail : store,
      module: 'breadcrumb',
    };
    this.storageService.setState(state);
  }
  public deleeCartItem(id) {
    let selectedCartItems = JSON.parse(
      localStorage.getItem('selectedCartItems')
    );
    for (let i = 0; i < selectedCartItems.length; i++) {
      if (selectedCartItems[i]['id'] == id) {
        selectedCartItems.splice(i, 1);
      }
    }
    localStorage.setItem(
      'selectedCartItems',
      JSON.stringify(selectedCartItems)
    );
  }
  public updateLineItem(item) {
    let req = {
      basketId: this.cartData.id,
      lineItemId: item.lineItemId,
      id: item.id,
      quantity: item.quantity,
      options: item.options ? item.options : [],
    };
    this.viewCart.updateLineItem(req).subscribe(
      (res) => {
        this.getBasket();
        this.loader = false;
        this.showCartShimmer = false;
        this.showDecrementShimmer = false;
      },
      (error: any) => {
        this.loader = false;
        this.showCartShimmer = false;
        this.showDecrementShimmer = false;
        if (
          error.error.status == 400 ||
          error.error.status == 401 ||
          error.error.status == 500
        ) {
          this.commonFunction.displaySnackBarMessage(
            error.error.response[0],
            'failure'
          );
        }
      }
    );
  }
  public deleteLineItem(item) {
    let req = {
      basketId: this.cartData.id,
      lineItemId: item.lineItemId,
    };
    this.viewCart.deleteLineItem(req).subscribe(
      (res) => {
        this.showDecrementShimmer = false;
        this.deleeCartItem(item.id);
        if (this.cartItemQuantity == 0 && this.cartData['items'].length == 1) {
          let selectedCartItems = [];
          localStorage.setItem(
            'selectedCartItems',
            JSON.stringify(selectedCartItems)
          );
          this.noItem = true;
          this.clearCartDatas();
        } else {
          this.getBasket();
        }
        this.loader = false;
        this.loaderOverlayService.hideLoader();
      },
      (error: any) => {
        this.showDecrementShimmer = false;
        this.loader = false;
        this.showCartShimmer = false;
        if (
          error.error.status == 400 ||
          error.error.status == 401 ||
          error.error.status == 500
        ) {
          this.commonFunction.displaySnackBarMessage(
            error.error.response[0],
            'failure'
          );
        }
      }
    );
  }
  public placeOrder(formdata) {
    this.refreshMenu();
    this.checkOOS();
  }
  placeFinalOrder() {
    if (!this.inStockAllProduct || this.inStockAllModifier) {
      return;
    }
    let snackbarData = JSON.parse(localStorage.getItem('snackbarData'));
    if (
      this.paymentDetails[0]['data'].balance >=
      snackbarData['response'].total.value ||
      this.paymentDetails[0].paymentMode == 'ONLINE'
    ) {
      this.initiateTransaction();
    } else if (
      this.paymentDetails[0]['data'].balance < snackbarData['response'].total.value ||
      this.paymentDetails[0].paymentMode == 'CASH'
    ){
      this.initiateTransactionForCash();
    } else if (
      this.paymentDetails[0]['data'].balance < snackbarData['response'].total.value ||
      this.paymentDetails[0].paymentMode == 'MANUAL_EDC'
    ){
      this.initiateTransactionForManualEdc();
    } 
    else if( this.paymentDetails[0]['data'].balance < snackbarData['response'].total.value){
      let payDetails = JSON.parse(localStorage.getItem('paymentModeDetails'));
      let data = payDetails[0].data;
      sessionStorage.setItem('amountToReload', data.amountToBeReloaded);
      const bottomSheetRef = this._bottomSheet.open(
        LoadMSRBalanceSheetComponent,
        {
          backdropClass: 'light-backdrop',
          panelClass: ['full_width_panel', 'bottom-sheet-height'],
          data,
        }
      );
      bottomSheetRef.afterDismissed().subscribe((res) => { });
    }
  }
  lineItems = [];
  productId = [];
  public initiateTransaction() {
    this.commonFunction.showLoader();
    this.lineItems = [];
    this.productId = [];
    let snackbarData = JSON.parse(localStorage.getItem('snackbarData'));
    let cartData = snackbarData['response'];
    let menuListItem = JSON.parse(
      LZString.decompress(localStorage.getItem('menuListItem'))
    );
    if (cartData) {
      for (let i = 0; i < cartData['items'].length; i++) {
        menuListItem.forEach((res) => {
          res['subCategories'].forEach((data) => {
            data['items'].forEach((itm) => {
              if (+cartData['items'][i]['id'] === +itm['id']) {
                this.tempCatId = res.id;
                this.tempProductImg = itm['images']['small'][0]['url'];
                return;
              }
            });
          });
        });
        let obj = {
          categoryId: this.tempCatId,
          productId: cartData['items'][i]['id'],
          productName: cartData['items'][i]['name'],
          productImage: this.tempProductImg,
        };
        this.lineItems.push(obj);
      }
    }
      let requestPayload = {
        basketId: cartData['id'],
        omniChannel: 'KIOSK',
        noOfProducts: cartData['items'].length,
        pickupType: this.viewCartFormGroup.get('pickuptypes').value,
        lineItems: this.lineItems,
        orderInstructions: this.viewCartFormGroup.get('textmssg').value,
        emailId: this.viewCartFormGroup.get('emailId').value == '' ? null : this.viewCartFormGroup.get('emailId').value,
        mobileNumber:this.viewCartFormGroup.get('mobileNumber').value,
        firstName: this.viewCartFormGroup.get('fname').value,
        deliveryType:"PICKUP",
      };
      this.paymentGatewayService.intiateTxnForCash(requestPayload).subscribe(
        (result: any) => {
          this.orderId = result.response.orderId;
          this.commonFunction.hideLoader();
          sessionStorage.setItem('orderFrom', 'orderFromCart');
          if (
            this.paymentDetails[0].paymentMode == 'ONLINE' &&
            this.cartData.total.value > 0
          ) {
            this.createSession();
          }
           else if (
            this.paymentDetails[0].paymentMode == 'MSR' &&
            this.cartData.total.value > 0
          ) {
            this.router.navigate(['/payment-activity'], {
              queryParams: {
                order_id: this.encryptDecryptService.decryptData(this.orderId),
                status: 'CHARGED',
                status_id: '21',
              },
            });
          } else if (this.cartData.total.value === 0) {
            let object = {
              paymentMode: 'COUPON',
              data: 'COUPON',
            };
            this.paymentDetails = [];
            this.paymentDetails.push(object);
            localStorage.setItem(
              'paymentModeDetails',
              JSON.stringify(this.paymentDetails)
            );
            this.router.navigate(['/payment-activity'], {
              queryParams: {
                order_id: this.encryptDecryptService.decryptData(this.orderId),
                status: 'CHARGED',
                status_id: '21',
              },
            });
          }
        },
        (error) => {
          this.commonFunction.hideLoader();
          this.commonFunction.displaySnackBarMessage(
            error.error.response[0],
            'failure'
          );
        }
      );
  }
    /**
   * Method to Iniialise the payment for cash in order to get Order Id
   */
  public initiateTransactionForCash() {
    this.lineItems = [];
    this.productId = [];
    let snackbarData = JSON.parse(localStorage.getItem('snackbarData'));
    let cartData = snackbarData['response'];
    let menuListItem = JSON.parse(
      LZString.decompress(localStorage.getItem('menuListItem'))
    );
      this.commonFunction.showLoader();
    if (cartData) {
      for (let i = 0; i < cartData['items'].length; i++) {
        menuListItem.forEach((res) => {
          res['subCategories'].forEach((data) => {
            data['items'].forEach((itm) => {
              if (+cartData['items'][i]['id'] === +itm['id']) {
                this.tempCatId = res.id;
                this.tempProductImg = itm['images']['small'][0]['url'];
                return;
              }
            });
          });
        });
        let obj = {
          categoryId: this.tempCatId,
          productId: cartData['items'][i]['id'],
          productName: cartData['items'][i]['name'],
          productImage: this.tempProductImg,
        };
        this.lineItems.push(obj);
      }
    }
    let requestPayload = {
      basketId: cartData['id'],
      omniChannel: 'KIOSK',
      noOfProducts: cartData['items'].length,
      pickupType: this.viewCartFormGroup.get('pickuptypes').value,
      lineItems: this.lineItems,
      orderInstructions: this.viewCartFormGroup.get('textmssg').value,
      mobileNumber:this.viewCartFormGroup.get('mobileNumber').value,
      firstName: this.viewCartFormGroup.get('fname').value,
      deliveryType:"PICKUP",
      emailId: this.viewCartFormGroup.get('emailId').value == '' ? null : this.viewCartFormGroup.get('emailId').value,
    };
    this.paymentGatewayService.intiateTxnForCash(requestPayload).subscribe(
      (result: any) => {
        this.orderId = result.response.orderId;
        this.commonFunction.hideLoader();
        sessionStorage.setItem('orderFrom', 'orderFromCart');
        if (
          this.paymentDetails[0].paymentMode == 'CASH' &&
          this.cartData.total.value > 0
        ) {
          this.router.navigate(['/payment-activity'], {
            queryParams: {
              order_id: this.orderId,
              status: 'CHARGED',
              status_id: '21',
            },
          });
        } 
         else if (this.cartData.total.value === 0) {
          let object = {
            paymentMode: 'COUPON',
            data: 'COUPON',
          };
          this.paymentDetails = [];
          this.paymentDetails.push(object);
          localStorage.setItem(
            'paymentModeDetails',
            JSON.stringify(this.paymentDetails)
          );
          this.router.navigate(['/payment-activity'], {
            queryParams: {
              order_id: this.encryptDecryptService.decryptData(this.orderId),
              status: 'CHARGED',
              status_id: '21',
            },
          });
        }
      },
      (error) => {
        this.commonFunction.hideLoader();
        this.commonFunction.displaySnackBarMessage(
          error.error.response[0],
          'failure'
        );
    }
    );
  }
 /**
* Method to use the Payment for Manual Edc 
*/
  public initiateTransactionForManualEdc(){
    this.lineItems = [];
    this.productId = [];
    let snackbarData = JSON.parse(localStorage.getItem('snackbarData'));
    let cartData = snackbarData['response'];
    let menuListItem = JSON.parse(
      LZString.decompress(localStorage.getItem('menuListItem'))
    );
      this.commonFunction.showLoader();
    if (cartData) {
      for (let i = 0; i < cartData['items'].length; i++) {
        menuListItem.forEach((res) => {
          res['subCategories'].forEach((data) => {
            data['items'].forEach((itm) => {
              if (+cartData['items'][i]['id'] === +itm['id']) {
                this.tempCatId = res.id;
                this.tempProductImg = itm['images']['small'][0]['url'];
                return;
              }
            });
          });
        });
        let obj = {
          categoryId: this.tempCatId,
          productId: cartData['items'][i]['id'],
          productName: cartData['items'][i]['name'],
          productImage: this.tempProductImg,
        };
        this.lineItems.push(obj);
      }
    }
    let requestPayload = {
      basketId: cartData['id'],
      omniChannel: 'KIOSK',
      noOfProducts: cartData['items'].length,
      pickupType: this.viewCartFormGroup.get('pickuptypes').value,
      lineItems: this.lineItems,
      orderInstructions: this.viewCartFormGroup.get('textmssg').value,
      mobileNumber:this.viewCartFormGroup.get('mobileNumber').value,
      firstName: this.viewCartFormGroup.get('fname').value,
      deliveryType:"PICKUP",
      emailId: this.viewCartFormGroup.get('emailId').value == '' ? null : this.viewCartFormGroup.get('emailId').value,
    };
    this.paymentGatewayService.intiateTxnForCash(requestPayload).subscribe(
      (result: any) => {
        this.orderId = result.response.orderId;
        this.commonFunction.hideLoader();
        sessionStorage.setItem('orderFrom', 'orderFromCart');
        if (
          this.paymentDetails[0].paymentMode == 'MANUAL_EDC' &&
          this.cartData.total.value > 0
        ) {
          this.router.navigate(['/payment-activity'], {
            queryParams: {
              order_id: this.orderId,
              status: 'CHARGED',
              status_id: '21',
            },
          });
        } 
         else if (this.cartData.total.value == 0) {
          let object = {
            paymentMode: 'COUPON',
            data: 'COUPON',
          };
          this.paymentDetails = [];
          this.paymentDetails.push(object);
          localStorage.setItem(
            'paymentModeDetails',
            JSON.stringify(this.paymentDetails)
          );
          this.router.navigate(['/payment-activity'], {
            queryParams: {
              order_id: this.encryptDecryptService.decryptData(this.orderId),
              status: 'CHARGED',
              status_id: '21',
            },
          });
        }
      },
      (error) => {
        this.commonFunction.hideLoader();
        this.commonFunction.displaySnackBarMessage(
          error.error.response[0],
          'failure'
        );
    }
    );
  }
  createSession() {
    this.userProfileInfo = JSON.parse(localStorage.getItem('user_profile'));
    let req = {
      order_id: this.encryptDecryptService.encryptData(this.orderId),
      amount: this.encryptDecryptService.encryptData(this.cartData.total.value),
      currency: 'INR',
      customer_email: this.encryptDecryptService.encryptData(
        this.userProfileInfo.emailId
      ),
      customer_phone: this.encryptDecryptService.encryptData(
        this.userProfileInfo.mobileNumber
      ),
      return_url: environment.PG_CALLBACK_URL + 'payment-activity',
    };
    this.commonFunction.showLoader();
    this.paymentGatewayService.createSession(req).subscribe(
      (result: any) => {
        sessionStorage.setItem('lastPagePaymentGateway', JSON.stringify(true));
        this.commonFunction.hideLoader();
        window.location.replace(result.response.payment_links.web);
      },
      (error) => {
        this.commonFunction.hideLoader();
        this.commonFunction.displaySnackBarMessage(
          error.error.response[0],
          'failure'
        );
      }
    );
  }
  crossSellData;
  public crossAndUpSell(itemIdOfCart) {
    let req = {
      pageName: 'Cart',
      productIdList: itemIdOfCart,
    };
    this.viewCart.crossAndUpSell(req).subscribe(
      (res) => {
        this.crossSellData =
          res['response']['data'] && res['response']['data']['relatedProducts'];
        this.crossSellData && this.crossSellData.length != 0
          ? this.crossSellSliderData(this.crossSellData)
          : (this.sliderData.length = 0);
      },
      (error: any) => {
        this.loader = false;
        if (
          error.error.status == 400 ||
          error.error.status == 401 ||
          error.error.status == 500
        ) {
          this.commonFunction.displaySnackBarMessage(
            error.error.response[0],
            'failure'
          );
        }
      }
    );
  }
  sliderData = [];
  crossSellSliderData(relatedIds) {
    let relatedId = relatedIds.map((id) => Number(id));
    this.sliderData = [];
    let menuListItem = JSON.parse(
      LZString.decompress(localStorage.getItem('menuListItem'))
    );
    if (menuListItem) {
      relatedId.forEach((id) => {
        menuListItem.forEach((menu) => {
          menu['subCategories'].forEach((subCat) => {
            subCat['items'].forEach((itm) => {
              if (+id === +itm['id']) {
                this.sliderData.push(itm);
              }
            });
          });
        });
      });
      if (this.sliderData.length != 0) {
        this.sliderData = [
          ...new Map(
            this.sliderData.map((item) => [item['id'], item])
          ).values(),
        ];
      }
    }
  }
  addItem(data) {
    localStorage.setItem('selectedItem', JSON.stringify(data));
    sessionStorage.setItem('previosPage', 'Cart');
    const navigationExtras: NavigationExtras = {
      state: {
        allMenuList: this.menuListData,
        storeDetails: this.storeDetails,
      },
    };
    this.commonFunction.dynamicURL(data, navigationExtras);
  }
  menuListData;
  storeDetails;
  getNavData() {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation.extras.state as {
      allMenuList: any;
      storeDetails: any;
    };
    if (state?.allMenuList) {
      this.menuListData = state?.allMenuList;
      this.storeDetails = state?.storeDetails;
    } else {
    }
  }
  public customized(item, price) {
    let product;
    sessionStorage.setItem('productForCustomisation', JSON.stringify(item));
    sessionStorage.setItem('previosPage', 'Cart');
    let menuListItem = JSON.parse(
      LZString.decompress(localStorage.getItem('menuListItem'))
    );
    if (menuListItem) {
      menuListItem.map((res) => {
        res['subCategories'].map((ress) => {
          ress['items'].map((itm) => {
            if (itm['id'] === item['id']) {
              product = itm;
              localStorage.setItem('selectedItem', JSON.stringify(itm));
              itm['options'] != null
                ? this.defaultCustomized(itm['options']['customization'])
                : '';
            }
          });
        });
      });
    }
    const navigationExtras: NavigationExtras = {
      state: {
        allMenuList: this.menuListData,
        storeDetails: this.storeDetails,
      },
    };
    this.commonFunction.dynamicURL(product, navigationExtras);
  }
  public defaultCustomized(customiseData) {
    if (customiseData && customiseData.modifiersItems.length != 0) {
      customiseData.modifiersItems.map((res) => {
        res['items'].map((itm) => {
          res['defaultItemIds'][0] === itm['id']
            ? (itm['click'] = true)
            : (itm['click'] = false);
        });
      });
      let defaultSelections = customiseData.modifiersItems.map((obj) => {
        return { ...obj };
      });
      sessionStorage.setItem(
        'defaultSelections',
        JSON.stringify(defaultSelections)
      );
    }
  }
  public openLoginDialog(): void {
    sessionStorage.setItem('module', 'cart');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = 'cart';
    dialogConfig.disableClose = true;
    dialogConfig.minWidth = '45vw';
    dialogConfig.maxWidth = '70vw';
    const dialogRef = this.dialog.open(LoginDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'cart') {
        this.router
          .navigateByUrl('/CartComponent', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/cart']);
          });
      }
      if (result == 'guest') {
        this.router.navigate(['/ordering/guest-login']);
      }
      if (!result) {
        let module = sessionStorage.getItem('module');
        if (module === 'cart') {
          this.router
            .navigateByUrl('/CartComponent', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/cart']);
            });
        }
      }
    });
  }
  public allOfferCouponCodes = [];
  public getChorotItem() {
    this.allOfferCouponCodes = [];
    this.allOffers = '';
    let cohortData = JSON.parse(localStorage.getItem('cohortData'));
    if (cohortData) {
      this.allOffers = cohortData.offers;
      if (this.allOffers) {
        this.allOffers.forEach((element) => {
          this.allOfferCouponCodes.push(element.couponCode);
        });
        this.getApplicableOffers();
      }
    } else {
      this.getCohortContent();
    }
  }
  /**
   * Method to get cohort data
   */
  public getCohortContent() {
    this.cmsService.getCmsCohortContent().subscribe((response) => {
      localStorage.removeItem('cohortData');
      localStorage.setItem('cohortData', JSON.stringify(response['response']));
      this.getChorotItem();
    });
  }
  public getApplicableOffers(): any {
    this.applicableOffersArrayNew = [];
    this.applicableOffersArray = [];
    this.nonApplicableOffersArray = [];
    this.showOfferShimmer = true;
    let basketId = this.storageService.getBasketId();
    let requestPayload = {
      basketId: basketId,
      coupons: this.allOfferCouponCodes,
    };
    this.couponService.getApplicableCoupons(requestPayload).subscribe(
      (result) => {
        this.applicableOffersArray = result['response']['applicableCoupons'];
        this.applicableOffersArray.forEach((element1) => {
          this.allOffers.forEach((element) => {
            if (element.couponCode == element1.couponNo) {
              let obj = {
                couponImageUrl: element.imageUrl,
                conditionLevel: element1.conditionLevel,
                couponNo: element1.couponNo,
                discountLevel: element1.discountLevel,
                expiryDate: element.endDate,
                isApplied: false,
                items: element1.items,
                title: element.title,
                content: element.content,
                promoType: element1.promoType,
                offerCategory: element.offerCategory,
                promotionDescription: element1.promotionDescription,
                promotionName: element1.promotionName,
                showDetails: false,
                uniqueIndex: null,
              };
              this.applicableOffersArrayNew.push(obj);
            }
          });
        });
        this.nonApplicableOffersArray = this.allOffers.filter(
          (item) =>
            !this.applicableOffersArrayNew.some(
              (item1) => item.couponCode == item1.couponNo
            )
        );
        this.showOfferShimmer = false;
        this.applicableIndex();
      },
      (error: any) => {
        this.applicableOffersArrayNew = [];
        this.showOfferShimmer = false;
      }
    );
  }
  nubmer = 1;
  uniqCoupnArray;
  couponCountDisplay;
  applicableIndex() {
    this.nubmer = 1;
    this.uniqCoupnArray = [];
    this.couponCountDisplay = [];
    let duplicateCouponNo = this.applicableOffersArrayNew
      .map((e) => e['couponNo'])
      .map((e, i, final) => final.indexOf(e) !== i && i)
      .filter((obj) => this.applicableOffersArrayNew[obj])
      .map((e) => this.applicableOffersArrayNew[e]['couponNo']);
    this.uniqCoupnArray = [...new Set(duplicateCouponNo)];
    for (let i = 0; i < this.applicableOffersArrayNew.length; i++) {
      if (
        this.uniqCoupnArray.includes(
          this.applicableOffersArrayNew[i]['couponNo']
        )
      ) {
        if (i > 0) {
          this.applicableOffersArrayNew[i - 1]['couponNo'] !=
            this.applicableOffersArrayNew[i]['couponNo']
            ? (this.nubmer = 1)
            : '';
        }
        this.applicableOffersArrayNew[i]['uniqueIndex'] =
          this.applicableOffersArrayNew[i]['couponNo'] + '_' + this.nubmer;
        this.applicableOffersArrayNew[i]['duplicate'] = true;
        this.nubmer++;
      } else {
        this.nubmer = 1;
      }
    }
    this.showSelectedOffers();
  }
  showSelectedOffers() {
    this.appliedCpnArray = [];
    let clonedResponse = this.cartData['coupons'].map((a) => {
      return { ...a };
    });
    if (clonedResponse.length != 0) {
      clonedResponse.forEach((res) => {
        this.applicableOffersArrayNew.forEach((item) => {
          if (res.uniqueIndex && item.uniqueIndex) {
            if (res['uniqueIndex'] == item.uniqueIndex) {
              res['showDetails'] = false;
              res['content'] = item.content;
              res['title'] = item.title;
              res['isApplied'] = true;
              res['items'] = item.items;
              res['expiryDate'] = item.expiryDate;
              this.appliedCpnArray.push(res);
              this.applicableOffersArrayNew.splice(
                this.applicableOffersArrayNew.findIndex(function (i) {
                  return i.uniqueIndex == item.uniqueIndex;
                }),
                1
              );
            } else {
            }
          } else {
            if (res.couponCode == item.couponNo) {
              this.applicableOffersArrayNew.splice(
                this.applicableOffersArrayNew.findIndex(function (i) {
                  return i.couponNo == item.couponNo;
                }),
                1
              );
              res['showDetails'] = false;
              res['content'] = item.content;
              res['title'] = item.title;
              res['items'] = item.items;
              res['couponNo'] == item.couponCode;
              res['expiryDate'] = item.expiryDate;
              res['isApplied'] = true;
              this.appliedCpnArray.push(res);
            }
          }
        });
      });
    }
    if (this.appliedCpnArray.length > 0) {
      this.appliedCpnArray.forEach((item) => {
        let itemsIds = item.itemsIds && item.itemsIds[0];
        item.items.forEach((res) => {
          if (res.itemId == itemsIds) {
            res['selectedLineItem'] = true;
          } else {
            res['selectedLineItem'] = false;
          }
        });
      });
    } else {
    }
    this.unUsedApplicableOffers();
  }
  unUsedApplicableOffers() {
    let nonApplicableLineItem;
    if (this.applicableOffersArrayNew.length != 0) {
      nonApplicableLineItem = this.applicableOffersArrayNew.filter((data) => {
        if (data.offerCategory === 'bxgy') {
          return data['items'].every((x) => x.isApplicablePromoItem == false);
        } else {
          return data['items'].every((x) => x.isApplicableItem == false);
        }
      });
      this.applicableOffersArrayNew = this.applicableOffersArrayNew.filter(
        (data) => {
          if (data.offerCategory === 'bxgy') {
            return !data['items'].every(
              (x) => x.isApplicablePromoItem == false
            );
          } else {
            return !data['items'].every((x) => x.isApplicableItem == false);
          }
        }
      );
      this.nonApplicableOffersArray = [
        ...this.nonApplicableOffersArray,
        ...nonApplicableLineItem,
      ];
    }
    this.couponCount();
  }
  couponCount() {
    let applicable = this.applicableOffersArrayNew.length;
    this.couponCountDisplay = applicable;
  }
  public openPaymentMode() {
    if (this.verifyLoggedInUser) {
      this.selectPayment();
    }
  }
  public baristaInfo: Object;
  public baristaMessage() {
    let barsitaGroupTwo = sessionStorage.getItem('barsitaGroupTwo');
    if (barsitaGroupTwo === 'Cart') {
      this.baristaInfo = this.commonFunction.displayBristaMessage('Cart');
    }
  }
  public starryInfo;
  public showStarryInfo() {
  let starryScreen = sessionStorage.getItem('starryScreen');
  let hideStarryScreen = sessionStorage.getItem('hideStarryScreen');
  if (hideStarryScreen) {
  if (hideStarryScreen && hideStarryScreen != 'Cart') {
  if (starryScreen === 'Cart') {
  this.starryInfo = this.commonFunction.displayStarryMessage('Cart');
  if (this.starryInfo) {
  this._snackBar.openFromComponent(StarryTipComponent, {
  data: this.starryInfo,
  horizontalPosition: 'end',
  verticalPosition: 'bottom',
  panelClass: ['starry-snackbar'],
  });
          }
        }
      }
    } else {
      if (starryScreen === 'Cart') {
  this.starryInfo = this.commonFunction.displayStarryMessage('Cart');
  if (this.starryInfo) {
  this._snackBar.openFromComponent(StarryTipComponent, {
  data: this.starryInfo,
  horizontalPosition: 'end',
  verticalPosition: 'bottom',
  panelClass: ['starry-snackbar'],
  });
        }
      }
    }
  }
  toggleContent(index, limit) {
    this.isContentToggled[index] = !this.isContentToggled[index];
    this.content[index] = this.isContentToggled[index]
      ? this.nonEditedContent[index]
      : this.itemCustomizationArr[index].slice(0, limit);
  }
  toggleDropdown() {
    this.showDiscountBar = !this.showDiscountBar;
  }
  expandImage(data) {
    if (!data.inStock) {
      return;
    }
  }
  gotoPrevious() {
    this._location.back();
  }
  addMore() {
    this.router.navigate(['/ordering']);
  }
  public proceedToPay() {
    if (sessionStorage.getItem('reloadCardPay') == 'true') {
      this.paymentDetails = [];
      let object = {
        paymentMode: 'MSR',
        data: JSON.parse(sessionStorage.getItem('reloadedCard')),
      };
      this.paymentDetails.push(object);
      localStorage.setItem(
        'paymentModeDetails',
        JSON.stringify(this.paymentDetails)
      );
      if (localStorage.getItem('MSR_cards') != null) {
        this.msrCardsData.forEach((element) => {
          if (element.cardOid == this.paymentDetails[0]['data'].cardOid) {
            this.paymentDetails[0]['data'].balance = element.balance;
            this.cardReloadedBalance = element.balance;
          }
        });
        let snackbarData = JSON.parse(localStorage.getItem('snackbarData'));
        if (this.cardReloadedBalance >= snackbarData['response'].total) {
          this.placeOrder(this.viewCartFormGroup.value);
        }
      }
    }
  }
  /**
   * Method to update cart from guest to login
   */
  public updateCart() {
    let basketId = this.storageService.getBasketId();
    let resquestPayload = {
      basketId: basketId,
    };
    this.viewCart.updateBasket(resquestPayload).subscribe((res) => {
      if (res['response'][0] === 'Customer details are updated') {
        sessionStorage.removeItem('updateCart');
        this.getBasket();
      } else {
        this.getBasket();
      }
    });
  }
  public selectPayment() {
    if (!this.inStockAllProduct || this.inStockAllModifier) {
      return;
    }
    let message = this.viewCartFormGroup.get('textmssg').value;
    let pickuptypes = this.viewCartFormGroup.get('pickuptypes').value;
    let firstName = this.viewCartFormGroup.get('fname').value;
    let mobNumber = this.viewCartFormGroup.get('mobileNumber').value;
    let email = this.viewCartFormGroup.get('emailId').value;
    const navigationExtras: NavigationExtras = {
      state: {
        pickupDetails: pickuptypes,
        request: message ? message : '',
        fname:firstName ? firstName:'',
        mobileNumber: mobNumber ? mobNumber : '',
        emailId:email ? email : ''
      },
    };
    this.router.navigate(['/ordering/select-payment-mode'], navigationExtras);
  }
  public getPayData() {
    const navigation = this.router.getCurrentNavigation();
    let state = navigation.extras.state as {
      pickupDetails: any;
      request: any;
      fname:any;
      mobileNumber:any;
      emailId:any
    };
    if (state) {      
      this.pickupDetails = state.pickupDetails;
      this.request = state.request;
      this.fname = state.fname;
      this.mobileNumber = state.mobileNumber;
      this.emailId = state.emailId;
      this.pickupDetails
        ? this.pickupDetails
        : (this.pickupDetails = 'takeaway');
      this.request ? this.request : (this.request = '');
      this.fname ? this.fname : (this.fname = '');
      this.mobileNumber ? this.mobileNumber :(this.mobileNumber = '');
      this.emailId ? this.emailId :(this.emailId = '')
    }
  }
  setForm() {
    if(this.viewCartFormGroup.invalid == true){
      this.viewCartFormGroup.markAllAsTouched();
    }
    this.pickupDetails ? this.pickupDetails : (this.pickupDetails = 'takeaway');
    this.viewCartFormGroup.get('textmssg').patchValue(this.request);
    this.viewCartFormGroup.get('pickuptypes').patchValue(this.pickupDetails);
    this.viewCartFormGroup.get('fname').patchValue(this.fname);
    this.viewCartFormGroup.get('mobileNumber').patchValue(this.mobileNumber);
    this.viewCartFormGroup.get('emailId').patchValue(this.emailId);
  }
  public setSeoData() {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      { name: 'keywords', content: 'Tata starbucks,best coffee' },
      {
        name: 'description',
        content: `tata starbucks simple recipe for coffee bacon donuts
      makes a sticky, Tata Starbucks Private Limited,
      formerly known as Tata Starbucks Limited,`,
      },
      { name: 'robots', content: 'index, follow' },
    ]);
  }
  public clearCartDatas() {
    this.loaderOverlayService.showLoader();
    let basketId = this.storageService.getBasketId();
    if (basketId) {
      let data = {
        basketId: basketId,
      };
      this.viewCart.deleteBasket(data).subscribe((res) => {
        localStorage.removeItem('snackbarData');
        localStorage.removeItem('manualCouponCode');
        this.storageService.clearBasketId();
        sessionStorage.removeItem('finalReqBodyArray');
        this.storageService.removeOrderType();
        sessionStorage.removeItem('orderType');
        localStorage.removeItem('reorderData');
        this.storageService.removereOrderData();
        sessionStorage.removeItem('finalReqBodyArray');
        this.loaderOverlayService.hideLoader();
        this.router.navigate(['/ordering']);
      });
    }
  }
  cartPageGA() {
    dataLayer.push({
      event: 'virtualpageview',
      page_location: window.location.href,
      page_title: this.title,
    });
  }
  guestUserPaymentClickGA() {
    dataLayer.push({
      event: 'guest_user_continue_with_payment_click',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
    });
  }
  applyOfferGA() {
    let pmtMethod = 'NA';
    if (
      this.paymentDetails &&
      this.paymentDetails.length != 0 &&
      this.paymentDetails[0].paymentMode == 'MSR'
    ) {
      pmtMethod = 'MSR';
    } else {
      pmtMethod = 'ONLINE';
    }
    dataLayer.push({
      event: 'view_cart_apply_offer_click',
      userID: this.userId,
      payment_method: pmtMethod,
      user_type: this.userType,
      tier: this.tierType,
    });
  }
  userPlaceOrderClickGA() {
    let isCouponApplied = this.appliedCouponData.length != 0 ? 'Yes' : 'No';
    dataLayer.push({
      event: 'your_cart_place_order_click',
      userID: this.userId,
      coupon_applied: isCouponApplied,
      pickup_details: 'Take-away',
      user_type: this.userType,
      tier: this.tierType,
    });
  }
  addToCartProductGA(additem, index) {
    let item = JSON.parse(localStorage.getItem('selectedItem'));
    let data = JSON.parse(sessionStorage.getItem('state'));
    dataLayer.push({
      event: 'add_to_cart',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
      ecommerce: {
        items: [
          {
            item_name: item.name,
            item_id: item.id,
            item_brand: 'Tata',
            affiliation: data ? data.storeDetails.shopName : 'NA',
            currency: 'INR',
            item_category: item.parameters[1].value,
            price: item.defaultPrice,
            item_variant: 'NA',
            index: index,
            quantity: 1,
          },
        ],
      },
    });
  }
  removeFromCartGA(removeitem, index) {
    let data = JSON.parse(sessionStorage.getItem('state'));
    let gaData = JSON.parse(sessionStorage.getItem('gaData'));
    let removeItemGaDetails;
    if (gaData && gaData.length > 0) {
      gaData.forEach((elem, i) => {
        if (elem.item_id == removeitem.id) {
          removeItemGaDetails = {
            item_list_id: elem.item_list_id,
            item_list_name: elem.item_list_name,
            promotion_name: elem.promotion_name,
          };
          if (elem.quantity > 1) {
            elem.quantity = elem.quantity - 1;
          } else if (elem.quantity == 1) {
            gaData.splice(i, 1);
          }
        }
      });
    } else {
      removeItemGaDetails = {
        item_list_id: 'NA',
        item_list_name: 'NA',
        promotion_name: 'NA',
      };
    }
    sessionStorage.setItem('gaData', JSON.stringify(gaData));
    dataLayer.push({
      event: 'remove_from_cart',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
      ecommerce: {
        items: [
          {
            item_name: removeitem.name,
            item_id: removeitem.id,
            item_brand: 'Tata',
            affiliation: data ? data.storeDetails.shopName : 'NA',
            currency: 'INR',
            item_category: removeitem.parameters[1].value,
            price: removeitem.price,
            item_list_name: removeItemGaDetails.item_list_name,
            item_list_id: removeItemGaDetails.item_list_id,
            item_variant: 'NA',
            promotion_name: removeItemGaDetails.promotion_name,
            index: index + 1,
            quantity: 1,
          },
        ],
      },
    });
  }
  customiseViewCartGA() {
    dataLayer.push({
      event: 'view_cart_customised_click',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
    });
  }
  orderCancelGA() {
    dataLayer.push({
      event: 'order_cancel_click',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
    });
  }
  gotoOrder(){
    this.router.navigate(['/ordering'],
    { queryParams: { storeId:  sessionStorage.getItem('storeId')} });  }
}
